import React from 'react';

export default function Logo(props) {
    return (
        <>
            <svg
                width="45"
                height="45"
                viewBox="0 0 45 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    d="M22.5 45C11.1218 44.9924 1.69424 36.7502 0 25.9826L11.5726 25.9615C13.0511 30.5281 17.3839 33.8338 22.5 33.8365C27.6079 33.8306 31.9347 30.5302 33.4186 25.9718L44.9874 25.9615C43.3052 36.7356 33.8798 44.9859 22.5 45ZM22.5 29.8558C18.3857 29.8558 15.0504 26.5624 15.0504 22.5C15.0504 18.4376 18.3857 15.1442 22.5 15.1442C26.6143 15.1442 29.9496 18.4376 29.9496 22.5C29.9496 26.5624 26.6143 29.8558 22.5 29.8558ZM0.0125988 19.0385C1.69479 8.26442 11.1202 0.0140636 22.5 1.07288e-06C33.8782 0.00757319 43.3058 8.24982 45 19.0174L33.4274 19.0385C31.9489 14.4719 27.6161 11.1662 22.5 11.1635C17.3921 11.1694 13.0653 14.4698 11.5814 19.0282L0.0125988 19.0385Z"
                    fill="#8257e6"
                />
            </svg>

            <h1 style={{ margin: '0', marginLeft: '10px' }}>Dex Docs</h1>
        </>
    );
}
